/**
 * Status states for Trouter subscriptions
 */ export var TrouterSubscriptionState = /*#__PURE__*/ function(TrouterSubscriptionState) {
    /** Subscription succeeded */ TrouterSubscriptionState["Subscribed"] = "Subscribed";
    /** Subscription failed */ TrouterSubscriptionState["Failed"] = "Failed";
    return TrouterSubscriptionState;
}({});
